import React from 'react';
import styles from './PatientCreateEdit.module.scss';
import moment from 'moment';

import api from '../../../helpers/api';
import SkinTypeSelector from '../../miscellaneous/SkinTypeSelector/SkinTypeSelector';
import GenderSelector from '../../miscellaneous/GenderSelector/GenderSelector';
import DateSelector from '../../miscellaneous/DateSelector/DateSelector';
import {$t} from '../../../helpers/translator';
import _ from "lodash";
import {setAlert} from "../../../store/alerts-slice";
import {getClinics} from "../../../store/data-slice";
import {connect} from "react-redux";
import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import InputWithValidation from "../../miscellaneous/InputWithValidation/InputWithValidation";

class PatientCreateEdit extends React.Component {
    constructor(props) {
        super(props);

        let birthDate = null;
        if (this.props.mode === 'edit') {
            let date = moment(this.props.patientData.birthDate);
            if (date.isValid()) {
                birthDate = date;
            }
        }

        let fieldErrors = {
            first_name: '',
            last_name: '',
            patient_id: '',
            birth_date: '',
            gender: '',
            skin_id: ''
        }

        if (this.props.userType === 3) {
            fieldErrors.clinic_id = ''
        }

        this.state = {
            key: 1,
            formSent: false,

            id: '',
            mode: 'create',
            userType: this.props.userType ? this.props.userType : 2,
            clinics: [],
            first_name: '',
            last_name: '',
            patient_id: '',
            birth_date: null,
            gender: 0,
            skin_id: null,
            clinic_id: null,
            fieldErrors: fieldErrors,
            errorText: '',

            success: false
        };
    }

    componentDidMount() {
        if (this.state.userType === 3) {
            this.getClinics();
        }
        this.setPatientDataFromProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.patientData) {
            this.setPatientDataFromProps(nextProps)
        }
    }

    setPatientDataFromProps(nextProps) {
        // console.log('setPatientDataFromProps', nextProps)

        let fieldErrors = {
            first_name: '',
            last_name: '',
            patient_id: '',
            birth_date: '',
            gender: '',
            skin_id: ''
        }

        if (nextProps.userType === 3) {
            fieldErrors.clinic_id = ''
        }

        let state = {
            key: this.state.key + 1,
            formSent: false,

            id: nextProps.patientData ? nextProps.patientData.id : '',
            mode: nextProps.mode ? nextProps.mode : 'create',
            userType: nextProps.userType ? nextProps.userType : 2,
            clinics: [],
            first_name: nextProps.patientData ? nextProps.patientData.first_name : '',
            last_name: nextProps.patientData ? nextProps.patientData.last_name : '',
            patient_id: nextProps.patientData ? nextProps.patientData.patient_id : '',
            birth_date: nextProps.patientData && nextProps.patientData.birth_date && moment(nextProps.patientData.birth_date).isValid() ? moment(nextProps.patientData.birth_date) : null,
            gender: nextProps.patientData ? nextProps.patientData.gender : 0,
            skin_id: nextProps.patientData ? nextProps.patientData.skin_id : null,
            clinic_id: nextProps.patientData && nextProps.userType === 3 ? nextProps.patientData.clinic_id : null,
            fieldErrors: fieldErrors,
            errorText: '',
            success: false
        };

        this.setState(state, () => {
            // console.log('state', this.state)
        })
    }

    async getClinics() {
        const clinics = await this.props.dispatch(getClinics());
        const selectedClinic = clinics.map((c, i) => {
            return {
                value: c.id,
                label: c.name,
                key: i
            }
        }).find(clinic => clinic.value === this.state.clinic_id);

        this.setState({
            clinics: clinics,
            selectedClinic: selectedClinic
        })
    }

    handleInputChange(name, value, errors) {
        // console.log('>>', name, value, errors);
        this.setState({[name]: value}, async () => {
            let fieldErrors = {...this.state.fieldErrors};
            fieldErrors[name] = errors && errors[0] ? errors[0] : '';

            this.setState({fieldErrors: fieldErrors});
        });
    }

    dateChange = (date) => {
        // console.log(date)

        let state = {...this.state};
        state.birth_date = date;
        state.fieldErrors.birth_date = '';

        this.setState(state);
    };

    async sendForm() {
        this.setState({errorText: '', formSent: true}, async () => {
            let validated = this.validateForm();
            if (!validated) {
                return;
            }

            let payload = {
                birthDate: moment(this.state.birth_date).format('YYYY-MM-DD HH:mm:ss'),
                first_name: this.state.first_name,
                gender: this.state.gender,
                last_name: this.state.last_name,
                patient_id: this.state.patient_id ? this.state.patient_id : null,
                skinID: this.state.skin_id,
                id: this.props.patientData ? this.props.patientData.id : null
            };

            if (this.state.userType === 3) {
                payload.clinic_id = this.state.clinic_id;
            }

            try {
                let res = {};
                if (this.state.mode === 'create') {
                    res = await api.post('patient/new', payload);
                } else {
                    res = await api.patch(`patient/${payload.id}`, payload);
                }

                if (res.data && res.data.success) {
                    let successText = this.props.mode === 'create' ? $t('global.patients.patientCreatedSuccessfully') : $t('global.patients.patientUpdatedSuccessfully')
                    this.props.dispatch(setAlert({type: 'success', body: successText}));
                    this.setState({success: true}, async () => {
                        this.emitSuccess(payload);
                        this.setState({
                            first_name: '',
                            last_name: '',
                            patient_id: '',
                            birth_date: null,
                            gender: 0,
                            skin_id: null,
                            clinic_id: null,
                            fieldErrors: {
                                first_name: '',
                                last_name: '',
                                patient_id: '',
                                birth_date: '',
                                gender: '',
                                skin_id: ''
                            },
                            errorText: '',
                            success: false
                        })
                        // await this.props.dispatch(setAlert('ALERT TXT'));
                    });
                } else {
                    let errorText = res.errorText ? res.errorText : $t('validation.general.errorOccurred');

                    this.setState({errorText: errorText});
                }
            } catch (e) {
                console.error('error: ');
                let errorText = $t('validation.general.errorOccurred');
                this.props.dispatch(setAlert({type: 'error', body: errorText}));
                this.setState({errorText: errorText});
            }
        });

    }

    validateForm() {
        let fieldErrors = {...this.state.fieldErrors};
        let validated = true;

        fieldErrors.birth_date = !this.state.birth_date ? 'This field is required' : '';
        fieldErrors.skin_id = !this.state.skin_id ? 'This field is required' : '';

        _.forEach(fieldErrors, (v, k) => {
            if (v) {
                validated = false;
            }
        });

        this.setState({fieldErrors: fieldErrors}, () => {
            // // console.error('err>>', fieldErrors)
            // return false;
        });
        return validated;
    }

    changeSkinType = (value) => {
        // console.log(value)
        let state = {...this.state};
        state.skin_id = value.value;
        state.fieldErrors.skin_id = '';

        this.setState(state);
    };

    changeGender = (value) => {
        let state = {...this.state};
        state.gender = value.value;
        state.fieldErrors.gender = '';

        this.setState(state);
    };

    /**
     * emitting success and data for parent to update accordingly
     * @param patient
     */
    emitSuccess(patient) {
        this.props.onSuccess({
            success: true,
            mode: this.state.mode,
            patient: patient
        });
    }

    render() {
        return (
            <div className={`${styles['container']}`}>
                <div>
                    <div
                        className={`${styles['header']}`}>{this.state.mode === 'edit' ? $t('global.patients.editPatientData') : $t('global.patients.addNewPatient')}</div>

                    {this.state.userType === 3 && <div className={styles["fields-row"]}>
                        <div className={styles["field-container"]}>
                            <div className={styles["field-name"]}>Clinic</div>
                            <div className={styles["field-input"]}>
                                <MultiSelect
                                    searchable={true}
                                    options={this.state.clinics.map((clinic) => {
                                        return {
                                            label: clinic.name,
                                            value: clinic.id
                                        };
                                    })}
                                    selected={this.state.selectedClinic}
                                    onValueChange={(data) => {
                                        this.setState({
                                            selectedClinic: data,
                                            clinic_id: data.value
                                        })
                                    }
                                    }
                                />
                            </div>
                            <div className={styles["field-error"]}>
                                {this.state.fieldErrors.patient_id}
                            </div>
                        </div>
                    </div>}

                    <div className={`${styles['fields-row']}`}>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.patientId')}</div>
                            <div className={`${styles['field-input-max']}`}>
                                <InputWithValidation
                                    key={this.state.key}
                                    name="patient_id"
                                    validations={['required', 'numeric', 'minLength(1)', 'maxLength(15)']}
                                    onChange={(data) => this.handleInputChange('patient_id', data.value, data.errors)}
                                    touched={this.state.formSent}
                                    type="text"
                                    value={{value: this.state.patient_id, errors: []}}
                                    // key={this.state.key}
                                    // placeholder={'placeholder'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles['fields-row']}`}>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.firstName')}</div>
                            <div className={`${styles['field-input']}`}>
                                <InputWithValidation
                                    key={this.state.key}
                                    name="first_name"
                                    validations={['required', 'name', 'minLength(2)', 'maxLength(20)']}
                                    onChange={(data) => this.handleInputChange('first_name', data.value, data.errors)}
                                    touched={this.state.formSent}
                                    type="text"
                                    value={{value: this.state.first_name, errors: []}}
                                />
                            </div>
                        </div>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.lastName')}</div>
                            <div className={`${styles['field-input-max']}`}>
                                <InputWithValidation
                                    key={this.state.key}
                                    name="last_name"
                                    validations={['required', 'name', 'minLength(2)', 'maxLength(20)']}
                                    onChange={(data) => this.handleInputChange('last_name', data.value, data.errors)}
                                    touched={this.state.formSent}
                                    type="text"
                                    value={{value: this.state.last_name, errors: []}}
                                    // placeholder={'placeholder'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles['fields-row']}`}>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.birthday')}</div>
                            <div className={`${styles['field-input']}`}>
                                <DateSelector className={`${styles['input']}`}
                                              key={this.state.key}
                                              maxDate={moment()}
                                              onDateChange={(date) => this.dateChange(date)}
                                              selected={this.state.birth_date}/>
                            </div>
                            <div className={`${styles['field-error']}`}>
                                {this.state.fieldErrors.birth_date}
                            </div>
                        </div>
                    </div>

                    <div className={`${styles['fields-row']}`}>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.gender')}</div>
                            <div className={`${styles['field-input']}`}>
                                <GenderSelector gender={this.state.gender} onValueChange={this.changeGender} key={this.state.key}/>
                            </div>
                            <div className={`${styles['field-error']}`}>
                                {this.state.fieldErrors.gender}
                            </div>
                        </div>
                        <div className={`${styles['field-container']}`}>
                            <div className={`${styles['field-name']}`}>{$t('global.patients.skinType')}</div>
                            <div className={`${styles['field-input']}`}>
                                <SkinTypeSelector skinType={this.state.skin_id} onValueChange={this.changeSkinType} key={this.state.key}/>
                            </div>
                            <div className={`${styles['field-error']}`}>
                                {this.state.fieldErrors.skin_id}
                            </div>
                        </div>
                    </div>

                    <div className={`${styles['button-row']}`}>
                        <div className={'alma-button'}
                             onClick={() => this.sendForm()}>{this.state.mode === 'edit' ? $t('global.patients.updatePatient') : $t('global.patients.addPatient')}</div>
                    </div>

                    <div className={`${styles['error-row']}`}>
                        <div>{this.state.errorText}</div>
                    </div>
                </div>

            </div>
        );
    }

}


// export default PatientCreateEdit;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(PatientCreateEdit);
